import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { getBadgeSetting, MemberBadge, } from './MemberBadge';
export const MemberBadges = ({ member, size = 'sm', location, singleLine = true, className, }) => {
    let memberBadges = (member === null || member === void 0 ? void 0 : member.badges) || [];
    if (location) {
        memberBadges = memberBadges.filter(memberBadge => {
            if (!(memberBadge === null || memberBadge === void 0 ? void 0 : memberBadge.badge)) {
                return false;
            }
            const locations = getBadgeSetting(memberBadge.badge, 'locations') || [];
            return locations.indexOf(location) !== -1;
        });
    }
    if (!(memberBadges === null || memberBadges === void 0 ? void 0 : memberBadges.length)) {
        return null;
    }
    return (_jsx("div", { className: clsx('flex gap-2 items-center', singleLine ? 'flex-nowrap' : 'flex-wrap', className), children: memberBadges.map(memberBadge => (_jsx(MemberBadge, { memberBadge: memberBadge, size: size, showTooltip: true }, memberBadge === null || memberBadge === void 0 ? void 0 : memberBadge.badgeId))) }, void 0));
};
//# sourceMappingURL=MemberBadges.js.map